import { useTranslation } from 'react-i18next';
import { useReveal } from '@/hooks/useReveal';

export function MapPreview() {
  const { t } = useTranslation();
  const { ref, visible } = useReveal<HTMLDivElement>();

  // Marcadores con su categoría, posición sobre el "mapa" y retardo de caída.
  const pins = [
    { label: t('map.pin_calzada'), top: '30%', left: '34%', delay: 200 },
    { label: t('map.pin_villa'), top: '52%', left: '58%', delay: 380 },
    { label: t('map.pin_castro'), top: '24%', left: '68%', delay: 560 },
    { label: t('map.pin_dolmen'), top: '68%', left: '28%', delay: 740 },
    { label: t('map.pin_miliario'), top: '60%', left: '80%', delay: 920 },
  ];

  return (
    <section id="map" className="relative bg-clay-900/30 py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-5">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-clay-50 sm:text-4xl">
            {t('map.title')}
          </h2>
          <p className="mt-4 text-lg text-clay-300">{t('map.subtitle')}</p>
        </div>

        {/* Mapa estilizado */}
        <div
          ref={ref}
          className="topo relative mt-14 aspect-[16/9] w-full overflow-hidden rounded-3xl border border-clay-300/15 bg-clay-950 shadow-2xl shadow-black/40"
        >
          {/* Retícula del mapa */}
          <div
            aria-hidden="true"
            className="absolute inset-0 opacity-40"
            style={{
              backgroundImage:
                'linear-gradient(rgba(212,179,132,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(212,179,132,0.06) 1px, transparent 1px)',
              backgroundSize: '48px 48px',
            }}
          />
          {/* Masa de terreno estilizada */}
          <svg
            viewBox="0 0 800 450"
            className="absolute inset-0 h-full w-full"
            preserveAspectRatio="xMidYMid slice"
            aria-hidden="true"
          >
            <path
              d="M150 260 C120 180 200 120 300 130 C360 90 470 100 520 150 C610 150 660 210 630 280 C660 340 560 390 470 370 C380 400 250 390 200 340 C150 330 140 300 150 260 Z"
              fill="rgba(146,64,14,0.22)"
              stroke="rgba(251,191,36,0.25)"
              strokeWidth="1.5"
            />
            <path
              d="M180 250 C170 200 230 170 290 175 M340 150 C420 150 480 170 520 200 M560 250 C580 300 520 340 470 340"
              fill="none"
              stroke="rgba(251,191,36,0.18)"
              strokeWidth="1.2"
              strokeDasharray="4 6"
            />
          </svg>

          {/* Chinchetas que caen al revelarse */}
          {pins.map((p, i) => (
            <div
              key={i}
              className="absolute"
              style={{
                top: p.top,
                left: p.left,
                opacity: visible ? 1 : 0,
                animation: visible ? `drop-pin 0.7s cubic-bezier(0.34,1.56,0.64,1) ${p.delay}ms both` : 'none',
              }}
            >
              <div className="group relative -translate-x-1/2 -translate-y-full">
                {/* Etiqueta */}
                <span className="absolute -top-9 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-amber-glow/30 bg-clay-950/90 px-3 py-1 text-xs font-medium text-amber-glow shadow-lg backdrop-blur">
                  {p.label}
                </span>
                {/* Pin */}
                <svg viewBox="0 0 24 32" className="h-8 w-6 drop-shadow-lg" aria-hidden="true">
                  <path
                    d="M12 0C5.4 0 0 5.4 0 12c0 8 12 20 12 20s12-12 12-20C24 5.4 18.6 0 12 0Z"
                    fill="#fbbf24"
                  />
                  <circle cx="12" cy="12" r="4.5" fill="#5a280b" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
